const data = () => {
  return (
    <div className="loader-container">
      <div className="spinner">test</div>
    </div>
  )
}

export default data
